import { Box, Button, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { Select as ViewList } from "../../../components/select";
import { CanalDistribuicaoViewProps } from "../canalDist.controll";
import { EstoqueCanalDistriuicao } from "../../../data.types";
import { CheckCircle } from "@mui/icons-material";
import { EstoqueDistCalc } from "../canalDist.model";
import ShowDialog from "../../../components/showDialog";
import { useState } from "react";

const columns: GridColDef[] = [
    { field: 'desc_item', headerName: 'Descricão', flex: 5, },
    { field: 'qt_entrada', headerName: 'Entrada', flex: 2 },
    { field: 'qt_saida', headerName: 'Saída', flex: 2 },
    { field: 'saldo', headerName: 'Saldo', flex: 2 },
]

export function CanalDistEstoque(props: CanalDistribuicaoViewProps) {
    const { row, estoqueCanal, changeList,loadingRows } = props.canalDistribuicaoState
    const { setSituacao, calcSaldoEstoqueCanal } = props.canalDistribuicaoActions

    const buttonSituacao = () => {
        const [openDialogAlterar, setOpenDialogAlterar] = useState(false);

        const handleCloseDialogAlterar = () => {
            setOpenDialogAlterar(false);
        };

        const handleAlterar = () => {
            setOpenDialogAlterar(false);
            if (row.situacao === "PENDENTE") {
                setSituacao("ABERTO")
            } else if (row.situacao === "ABERTO") {
                setSituacao("FECHADO")
            }
        };

        const ViewShowDialog = () => {
            return (
                <ShowDialog
                    title={"Confimar Alteração"}
                    msg={row.situacao === "PENDENTE" ? "Confirma a liberação da distribuição?" : "Confirma a finalização da distribuição?"}
                    close={handleCloseDialogAlterar}
                    ok={handleAlterar}
                    open={openDialogAlterar}
                />
            )
        }
        if (row.estoque_dist.length > 0 || row.situacao === "ABERTO") {
            switch (row.situacao) {
                case "PENDENTE":
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                            <ViewShowDialog />
                            <Button
                                variant="contained"
                                startIcon={<CheckCircle />}
                                color="success"
                                onClick={() => setOpenDialogAlterar(true)}
                            >
                                Liberar Distribuição
                            </Button>
                        </Box>
                    );
                case "ABERTO":
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                            <ViewShowDialog />
                            <Button
                                variant="contained"
                                startIcon={<CheckCircle />}
                                color="error"
                                onClick={() => setOpenDialogAlterar(true)}
                            >
                                Finalizar Distribuição
                            </Button>
                        </Box>
                    )

                default:
                    break;
            }
        }
    }
    return (
        <Box>
            <ViewList
                displayWidth={window.innerWidth}
                title={"Estoque do canal de distribuição"}
                row={row}
                showAlert={false}
                closeAlert={() => { }}
                msg={""}
                status={""}
                elevation={1}
                getRowId={(row: EstoqueDistCalc) => row.id_item}
                handleOnChange={() => { }}
                actionsOnkeyEnter={() => { }}
                showSearchContainer={false}
                fontSize={14}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"descricao"}
                columns={columns}
                rows={estoqueCanal}
                loading={loadingRows}
                setRow={() => { }}
                changeList={changeList}
                variantToobar="dense"
                buttonNew={{
                    show: false,
                    onClick: () => { }
                }}
                buttonRefresh={{
                    show: true,
                    onClick: () => calcSaldoEstoqueCanal()
                }}
                ListItemTextPrimary={(row: EstoqueCanalDistriuicao) => <Typography component={"span"}>{row.item.descricao}</Typography>}
                ListItemTextSecondary={(row: EstoqueCanalDistriuicao) =>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography component={"span"}>Qtde: {row.qt}</Typography>
                    </Box>
                }
            />
            <Box sx={{ mt: 2, display: 'flex', flexDirection: "row", justifyContent: 'flex-end' }}>
                {buttonSituacao()}
            </Box>

        </Box>
    )
}